import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (active) => L.divIcon({
  className: "",
  html: `<div style="width:${active ? 26 : 18}px;height:${active ? 26 : 18}px;border-radius:9999px;background:${active ? "#1B1530" : "#FF5A5F"};border:3px solid #fff;box-shadow:0 4px 12px rgba(27,21,48,.35)"></div>`,
  iconSize: [active ? 26 : 18, active ? 26 : 18],
  iconAnchor: [active ? 13 : 9, active ? 13 : 9],
});

const Controller = ({ stores, focus, markers }) => {
  const map = useMap();
  useEffect(() => {
    const pts = stores.map((s) => [s.lat, s.lng]);
    if (pts.length) map.fitBounds(pts, { padding: [40, 40], maxZoom: 13 });
  }, [stores, map]);
  useEffect(() => {
    if (!focus) return;
    map.flyTo([focus.lat, focus.lng], 15, { duration: 1 });
    const t = setTimeout(() => markers.current[focus.id]?.openPopup(), 1050);
    return () => clearTimeout(t);
  }, [focus, map, markers]);
  return null;
};

export const StoreMap = ({ stores, focus, onSelect }) => {
  const markers = useRef({});
  return (
    <div data-testid="stores-map" className="relative z-0 isolate h-full w-full rounded-[28px] overflow-hidden border border-[#1B1530]/10 bg-[#BDE3FA]">
      <MapContainer center={[45.5, -63.5]} zoom={6} scrollWheelZoom={false} className="h-full w-full">
        <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        {stores.map((s) => (
          <Marker key={s.id} position={[s.lat, s.lng]} icon={pin(focus?.id === s.id)}
            ref={(m) => { if (m) markers.current[s.id] = m; }} eventHandlers={{ click: () => onSelect(s) }}>
            <Popup>
              <strong>{s.name}</strong><br />{s.address}<br />
              <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${s.name}, ${s.address}`)}`} target="_blank" rel="noreferrer">Get directions</a>
            </Popup>
          </Marker>
        ))}
        <Controller stores={stores} focus={focus} markers={markers} />
      </MapContainer>
    </div>
  );
};
